export const createFormDataFromValues = <T extends object>(values: T) => {
  const formData = new FormData();

  Object.entries(values).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      // Handle arrays of objects with 'id' property (e.g., teams selection)
      if (Array.isArray(value)) {
        const serialized = value
          .map((item) =>
            item && typeof item === 'object' && 'id' in item ? item.id : item
          )
          .filter(Boolean)
          .join(',');
        if (serialized) {
          formData.append(key, serialized);
        }
      }
      // Handle single objects with 'id' property
      else if (typeof value === 'object' && 'id' in value) {
        formData.append(key, (value as { id: string }).id);
      }
      // Handle primitive values
      else if (typeof value !== 'object') {
        formData.append(key, String(value));
      }
      // Handle other objects (stringify as JSON fallback)
      else {
        formData.append(key, JSON.stringify(value));
      }
    }
  });

  return formData;
};

export const mergeFormData = (
  firstFormData: FormData,
  secondFormData: FormData
): FormData => {
  const mergedFormData = new FormData();

  for (const [key, value] of firstFormData.entries()) {
    mergedFormData.append(key, value);
  }

  for (const [key, value] of secondFormData.entries()) {
    mergedFormData.append(key, value);
  }

  return mergedFormData;
};

export const parseValueFromObjectOfObjects = <T>(
  input: Record<string, T>
): Record<string, string> => {
  const parsedValues: Record<string, string> = {};

  for (const key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      if (typeof input[key] === 'string') {
        parsedValues[key] = input[key] as string;
      } else {
        parsedValues[key] = JSON.stringify(input[key]);
      }
    }
  }

  return parsedValues;
};

/**
 * Normaliza el valor del selector de equipos a un array de ids.
 * Acepta el array del formulario, la cadena separada por comas que produce
 * `createFormDataFromValues`, un id suelto (borradores antiguos) o nada.
 */
export const toTeamIds = (raw: unknown): string[] => {
  if (Array.isArray(raw)) {
    return raw
      .filter(
        (item): item is string =>
          typeof item === 'string' && item.trim() !== ''
      )
      .map((item) => item.trim());
  }
  if (typeof raw === 'string' && raw.trim() !== '') {
    return raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
};
